import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type SignalStatistic = {
  signal: string;
  signal_key: string;
  signal_description: string;
  count: number;
  percentage: number;
};

// eslint-disable-next-line import/prefer-default-export
export function useSignalStatistics(queryParams: string) {
  return useQuery<SignalStatistic[]>({
    queryKey: [APIKey.SIGNAL_STATISTICS, queryParams],
    queryFn: () =>
      baseFetcher(`${apiRoutes.signalStatistics()}?${queryParams}`),
  });
}
